export default __webpack_public_path__ + "static/media/background_image.2da260a4.jpg";